import React from "react";

export default function SystemActivationGuide() {
  return (
    <>
      <h3 className="mt-4">Step 3: System Activation</h3>

      <ul>
        <li>
          ✅ After completing Menu, Services, Staff, Signatories, and Sources,
          inform us.
        </li>
        <li>
          ✅ We will activate your system for full control and live operation.
        </li>
      </ul>
    </>
  );
}
